
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_7478_39355)"}},[_c('path',{attrs:{"d":"M20.5 22H19v-3.5a7.01 7.01 0 00-4.4-6.5A7.011 7.011 0 0019 5.5V2h1.5a1 1 0 100-2h-17a1 1 0 000 2H5v3.5A7.011 7.011 0 009.4 12 7.01 7.01 0 005 18.5V22H3.5a1 1 0 000 2h17a1 1 0 000-2zM8.19 6.92a1 1 0 01.89-.544h5.84a1 1 0 01.811 1.584 4.591 4.591 0 01-7.462 0 1 1 0 01-.079-1.04zm-.27 11.71l3.044-2.936a1.544 1.544 0 012.07 0l3.043 2.935a1.349 1.349 0 01.269 1.6 1.46 1.46 0 01-1.3.771H8.957a1.46 1.46 0 01-1.3-.764 1.352 1.352 0 01.263-1.606z","fill":"#20182E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7478_39355"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    